import React, { Component, ReactNode } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

class CustomLoading extends Component<Props> {
  public render(): ReactNode {
    return (
      <div data-testid='loading' className='flex justify-center items-center h-full w-full'>
        <ProgressSpinner />
      </div>
    );
  }
}

type Props = {};

export default CustomLoading;
